import React from "react";
import lodash from "lodash";
const TableOptionsEiendomLeietaker = ({
  index,
  handleChange,
  disabled
}: any): JSX.Element => {
  const capitalize = lodash.capitalize(index.leietaker);
  return (
    <div className="flex">
      <select
        className="outline-none relative flex flex-grow justify-content
                                            py-2 text-lg border border-sk-primary-blue font-medium rounded-md
                                            text-black hover:border-blue-500 focus:ring-2 focus:ring-blue-600 text-justify"
        name="leietaker"
        title="leietaker"
        onChange={(e) => handleChange(e, index)}
        value={capitalize}
        disabled={disabled}
      >
        <option value="Velg et alternativ her..">
          Velg et alternativ her..
        </option>
        <option value="Egen virksomhet"> Egen virksomhet</option>
        <option value="Kommune"> Kommune</option>
        <option value="Privatperson">Privatperson</option>
      </select>
    </div>
  );
};
export default TableOptionsEiendomLeietaker;
